/**
 * Live chat Socket.IO event names.
 * Keep in sync with wabaserver/constants/liveChatSocket.js
 */

export const SOCKET_EVENTS = {
  NEW_MESSAGE: "new_message",
  MESSAGE_STATUS_UPDATE: "message_status_update",
  CHAT_ASSIGNED: "chat_assigned",
  TYPING: "typing",
  ERROR: "error",
  JOINED_CHAT: "joined_chat",
  SUBSCRIBED_CHAT: "subscribed_chat",
  JOINED_LIVECHAT: "joined_livechat",
  USE_LIVECHAT_ROOM: "use_livechat_room",
  // WhatsApp Business Calling
  INCOMING_CALL: "incoming_call",
  CALL_DIALING: "call_dialing",
  CALL_ANSWERED: "call_answered",
  CALL_CONNECTED: "call_connected",
  CALL_ENDED: "call_ended",
};

export const SOCKET_CLIENT_EVENTS = {
  JOIN_CHAT: "join_chat",
  LEAVE_CHAT: "leave_chat",
  JOIN_USER_ROOM: "join_user_room",
  LEAVE_USER_ROOM: "leave_user_room",
  JOIN_LIVECHAT_ROOM: "join_livechat_room",
  LEAVE_LIVECHAT_ROOM: "leave_livechat_room",
  SUBSCRIBE_ASSIGNED_CHAT: "subscribe_assigned_chat",
  UNSUBSCRIBE_CHAT: "unsubscribe_chat",
  TYPING: "typing",
};

/** How the client joined a per-chat room (for correct leave on unmount). */
export const CHAT_JOIN_MODE = {
  JOIN: "join",
  SUBSCRIBE: "subscribe",
};
